import { Footer } from 'common/Components/Footer';
import { useTranslation } from 'react-i18next';
import FormLogin from './components/FormLogin';
import { FingerPrintLogin } from './components/FingerPrintLogin';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

export const MobileLogin = () => {
  const { t } = useTranslation();
  const { hasFinger } = useSelector((state: RootState) => state.autorizationSlice);

 

  return (
    <div className="bg-L-gray-50 dark:bg-D-gray-50 h-[100vh] max-h-[100vh] overflow-hidden inset-0 relative grid grid-rows-min-one">
      <div className="px-4">
        <FormLogin />
        <div className="text-center">
          {/* <span className="pl-0.5 text-L-gray-300 dark:text-D-gray-300 text-xl ">
            {t(`FormSide.SignUp.Question`)}
          </span>
          <span className="text-L-success-150 dark:text-D-success-150 text-xl">
            {t(`FormSide.SignUp.Order`)}
          </span> */}
        </div>

        {
          hasFinger && (
            <div>
              <FingerPrintLogin />
            </div>
          )
        }

        <h5 className="text-2xl text-L-primary-50 pt-6 pb-2">{t(`Privacy.NoteTitle`)}:</h5>

      </div>

      <div className="w-full h-auto bg-img-login bg-cover px-4 overflow-y-auto bg-center">
        <Footer />
      </div>
    </div>
  );
};
